var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-9"},[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-xl-4 col-sm-6"},[_c('div',{staticClass:"mt-2"},[_c('h5',[_vm._v("Catalogo de Productos")])])])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }